import React from 'react';
import FooterV3Terms from '../PreAuthV3/PreauthFooterV3Terms';
import ZolaLogo from '../ZolaLogo';
import { LinkV2 } from '../LinkV2';
import {
  Container,
  ContentWrapper,
  ZolaIdentityWrapper,
  LinksSectionList,
  LinksSectionListItem,
  LinksSectionWrapper,
  LinksSectionTitle,
  ZolaSignature,
  LinksSectionsWrapper,
} from './FooterV2.styles';
import { HELP_LINKS_COLUMN_1, HELP_LINKS_COLUMN_2 } from './constants';

const FooterV2 = (): JSX.Element => (
  <Container>
    <ContentWrapper>
      <LinksSectionsWrapper>
        <LinksSectionWrapper>
          <LinksSectionTitle>Help</LinksSectionTitle>
          <LinksSectionList>
            {HELP_LINKS_COLUMN_1.map((link, index) => (
              <LinksSectionListItem>
                <LinkV2 href={link.href} key={index} subtle noUnderline noTextTransform>
                  {link.label}
                </LinkV2>
              </LinksSectionListItem>
            ))}
          </LinksSectionList>
        </LinksSectionWrapper>
        <LinksSectionWrapper>
          <LinksSectionList>
            {HELP_LINKS_COLUMN_2.map((link, index) => (
              <LinksSectionListItem>
                <LinkV2 href={link.href} key={index} subtle noUnderline noTextTransform>
                  {link.label}
                </LinkV2>
              </LinksSectionListItem>
            ))}
          </LinksSectionList>
        </LinksSectionWrapper>
      </LinksSectionsWrapper>
      <ZolaIdentityWrapper>
        <ZolaLogo color="#0E0E0E" />
        <ZolaSignature>For all the days along the way</ZolaSignature>
        <LinkV2 arrow href="/wedding-registry" noTextTransform>
          Start your wedding registry
        </LinkV2>
      </ZolaIdentityWrapper>
    </ContentWrapper>
    <FooterV3Terms />
  </Container>
);

export default FooterV2;
